import { render, staticRenderFns } from "./plain-editor.vue?vue&type=template&id=3e3f86f2&scoped=true&"
import script from "./plain-editor.vue?vue&type=script&lang=js&"
export * from "./plain-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f86f2",
  null
  
)

export default component.exports